import Input from "../../components/form/input/InputField";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const LeadCall = () => {
    const navigate = useNavigate();
    const [lead_id, ] = useState("9"); // Default lead_id for now
    const [call_date, setCallDate] = useState(""); // example: 2025-04-02 14:00:00
    const [location, setLocation] = useState("");
    const [agenda, setAgenda] = useState("");
    const [saving, setSaving] = useState<boolean>(false);

    const [errors, setErrors] = useState<{
        call_date?: string;
        location?: string;
        agenda?: string;
    }>({});

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setSaving(true);
        setErrors({});

        const newErrors: typeof errors = {};

        if (!call_date) newErrors.call_date = "Call date is required.";
        if (!location) newErrors.location = "Location is required.";
        if (!agenda) newErrors.agenda = "Agenda is required.";

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setSaving(false);
            return;
        }

        const formData = new FormData();
        formData.append("lead_id", lead_id);
        formData.append("call_date", call_date);
        formData.append("location", location);
        formData.append("agenda", agenda);

        const token = sessionStorage.getItem("access_token");
        if (!token) {
            toast.error("Authorization required. Please log in.");
            navigate("/signin");
            return;
        }

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/calls/create`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (response.data.code === 200) {
                toast.success(response.data.message || "Call created successfully!", {
                    autoClose: 1500,
                });

                setCallDate("");
                setLocation("");
                setAgenda("");

                navigate("/call-list");
                return;
            }

            toast.error("Unexpected server response. Please try again.", {
                autoClose: 2000,
            });
        } catch (error: any) {
            console.error("API Error:", error.response?.data || error.message);

            const errorMessage =
                error.response?.data?.message || "An unexpected error occurred.";
            toast.error(errorMessage, { autoClose: 2000 });
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-800 rounded-lg p-4 relative">
            <div className="px-0 py-1 flex items-center justify-between">
                <h2 className="text-xl font-semibold text-gray-800 dark:text-white/90">
                    Add Lead Call
                </h2>
                <button
                    type="button"
                    onClick={() => navigate("/call-list")}
                    className="px-4 py-1.5 text-sm bg-brand-500 text-white rounded-lg hover:bg-brand-600"
                >
                    View Call
                </button>
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-lg mt-4 overflow-hidden">
                <form
                    className="grid grid-cols-1 md:grid-cols-1 gap-6 items-start relative"
                    onSubmit={handleSubmit}
                >
                    <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div>
                            <label className="text-sm font-medium text-gray-800 dark:text-white/90 mb-1 block">
                                Call Date & Time <span className="text-error-500">*</span>
                            </label>
                            <Input
                                type="datetime-local"
                                value={call_date}
                                onChange={(e) => setCallDate(e.target.value)}
                                className={`w-full px-3 py-2 border rounded-md ${errors.call_date ? "border-red-500" : "border-gray-300"
                                    }`}
                            />
                            {errors.call_date && (
                                <span className="errorText">{errors.call_date}</span>
                            )}
                        </div>

                        <div>
                            <label className="text-sm font-medium text-gray-800 dark:text-white/90 mb-1 block">
                                Location <span className="text-error-500">*</span>
                            </label>
                            <Input
                                type="text"
                                value={location}
                                onChange={(e) => setLocation(e.target.value)}
                                className={`w-full px-3 py-2 border rounded-md ${errors.location ? "border-red-500" : "border-gray-300"
                                    }`}
                            />
                            {errors.location && (
                                <span className="errorText">{errors.location}</span>
                            )}
                        </div>

                        <div >
                            <label className="text-sm font-medium text-gray-800 dark:text-white/90 mb-1 block">
                                Agenda <span className="text-error-500">*</span>
                            </label>
                            <Input
                                type="text"
                                value={agenda}
                                onChange={(e) => setAgenda(e.target.value)}
                                className={`w-full px-3 py-2 border rounded-md ${errors.agenda ? "border-red-500" : "border-gray-300"
                                    }`}
                            />
                            {errors.agenda && (
                                <span className="errorText">{errors.agenda}</span>
                            )}
                        </div>
                    </div>

                    <div className="col-span-1 sm:col-span-3 p-4 flex justify-end gap-4 w-full">
                        <button
                            className="px-6 py-2 text-sm bg-brand-500 text-white rounded-lg hover:bg-brand-600 w-auto"
                            type="submit"
                            disabled={saving}
                        >
                            {saving ? "Saving..." : "Submit"}
                        </button>
                        <button
                            className="px-4 py-2 text-sm bg-white text-gray-700 ring-1 ring-gray-300 rounded-lg hover:bg-gray-50 dark:bg-gray-900 dark:text-gray-400 dark:ring-gray-700 w-auto"
                            type="button"
                            onClick={() => navigate("/call-list")}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default LeadCall;
